import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { AuthStore } from '../../../../core/stores';
import { NgOptimizedImage } from '@angular/common';
import { LanguageEnum } from '../../../../core/enums';

@Component({
  selector: 'dbx-entry-skeleton',
  standalone: true,
  imports: [TranslateModule, LanguageSwitcherComponent, NgOptimizedImage],
  templateUrl: './entry-skeleton.component.html',
  styleUrl: './entry-skeleton.component.scss',
})
export class EntrySkeletonComponent {
  private readonly authStore = inject(AuthStore);
  $language = this.authStore.language;

  setLanguage(language: LanguageEnum) {
    this.authStore.setLanguage(language);
  }
}
